import { configure } from "mobx";

configure({ useProxies: "never", enforceActions: "never" });
